import { Check, Download, ExternalLink, Images, Play, Trash2 } from "lucide-react";
import type { MediaItem } from "../types";

interface Props {
  item: MediaItem;
  admin: boolean;
  selectionMode: boolean;
  selected: boolean;
  onOpen: (item: MediaItem, index?: number) => void;
  onDelete: (item: MediaItem) => void;
  onToggleSelect: (id: string) => void;
}

const labels = { upload: "原创上传", douyin: "抖音", xiaohongshu: "小红书" } as const;

export function MediaCard({ item, admin, selectionMode, selected, onOpen, onDelete, onToggleSelect }: Props) {
  const cover = item.assets[0];
  const isVideo = cover?.mimeType.startsWith("video/");
  return (
    <article className={`media-card ${selectionMode ? "selection-enabled" : ""} ${selected ? "is-selected" : ""}`}>
      <button
        className="media-preview"
        onClick={() => selectionMode ? onToggleSelect(item.id) : onOpen(item)}
        aria-label={selectionMode ? `${selected ? "取消选择" : "选择"} ${item.title}` : `查看 ${item.title}`}
        aria-pressed={selectionMode ? selected : undefined}
      >
        {cover ? (
          isVideo ? (
            <video src={cover.url} muted playsInline preload="metadata" />
          ) : (
            <img src={cover.url} alt={item.title} loading="lazy" />
          )
        ) : (
          <div className="empty-cover"><Images size={34} /><span>媒体待恢复</span></div>
        )}
        <span className={`source-badge source-${item.kind}`}>{labels[item.kind]}</span>
        {selectionMode && <span className="selection-indicator" aria-hidden="true">{selected && <Check />}</span>}
        {isVideo && <span className="play-badge"><Play size={18} fill="currentColor" /></span>}
        {item.assets.length > 1 && <span className="asset-count"><Images size={15} /> {item.assets.length}</span>}
        <span className="preview-action">轻触查看</span>
      </button>
      <div className="media-card-body">
        <div>
          <h3>{item.title}</h3>
          <p>{item.sourceAuthor ? `@${item.sourceAuthor}` : new Intl.DateTimeFormat("zh-CN", { month: "short", day: "numeric" }).format(new Date(item.createdAt))}</p>
        </div>
        <div className="card-actions">
          {cover && <a href={cover.downloadUrl} title="保存原图" aria-label="保存原图"><Download size={18} /></a>}
          {item.sourceUrl && <a href={item.sourceUrl} target="_blank" rel="noreferrer" title="查看原链接" aria-label="查看原链接"><ExternalLink size={18} /></a>}
          {admin && !selectionMode && <button onClick={() => onDelete(item)} className="danger-ghost" title="删除" aria-label="删除"><Trash2 size={18} /></button>}
        </div>
      </div>
    </article>
  );
}
